import { Checkbox } from "@choose/ui/checkbox";
import {
  Command,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
  CommandList,
} from "@choose/ui/command";
import { useTranslation } from "react-i18next";

import type { SupportTicketSubStatus } from "~/graphql/graphql.gen";
import { getSubStatuses } from "~/stores/ticket-sub-statuses-store";

export function SubStatusSelector({
  activeOptions,
  multiple = false,
  onSelect,
  value,
}: {
  activeOptions?: SupportTicketSubStatus[];
  multiple?: boolean;
  onSelect: (userId: string, closeModal: boolean) => void;
  value: string[];
}) {
  const { t } = useTranslation();
  const subStatuses = getSubStatuses(t);

  const filteredSubStatuses = subStatuses.filter((item) => !item.disabled);

  return (
    <Command>
      <CommandInput placeholder={t("tickets.filters.status.placeholder")} />
      <CommandList>
        <CommandEmpty>{t("tickets.filters.status.empty")}</CommandEmpty>
        <CommandGroup>
          {filteredSubStatuses.map((item) => (
            <CommandItem
              key={item.value}
              value={item.value}
              keywords={[item.label]}
              onSelect={() => onSelect(item.value, true)}
              className="flex items-center justify-between"
              disabled={
                !!item.disabled ||
                (activeOptions && !activeOptions.includes(item.value))
              }
            >
              <div className="flex items-center gap-2">
                {multiple ? (
                  <Checkbox
                    onClick={(e) => {
                      e.stopPropagation();
                      onSelect(item.value, false);
                    }}
                    checked={value.includes(item.value)}
                    // Fixes shadcn overriding with data-selected:**:[svg]:text-foreground
                    className="data-checked:**:[svg]:text-primary-foreground!"
                  />
                ) : null}
                <item.icon style={{ color: item.color }} />
                {item.label}
              </div>
            </CommandItem>
          ))}
        </CommandGroup>
      </CommandList>
    </Command>
  );
}
